export const customStyles = {
    control: (_: any, { selectProps: { width, isDisabled } }: any) => ({
        display: 'flex',
        width: width,
        padding: '1px 2px 1px 0',
        cursor: isDisabled ? 'not-allowed' : 'default',
        color: isDisabled ? '#aaa' : 'white',
        backgroundColor: isDisabled ? '#e9ecef' : 'white',
        borderRadius: '0.5rem',
    }),
    placeholder: (defaultStyles: any) => ({
        ...defaultStyles,
        paddingLeft: '5px',
    }),
    input: (defaultStyles: any) => ({
        ...defaultStyles,
        paddingLeft: '3px',
    }),
    singleValue: (provided: any) => {
        return {
            ...provided,
            paddingLeft: '5px',
        };
    },
    menu: (defaultStyles: any) => {
        return {
            ...defaultStyles,
            zIndex: 999999,
        };
    }
}

export const customStylesSmallText = {
    control: (_: any, { selectProps: { width } }: any) => ({
        display: 'flex',
        width: width,
        padding: '0 15px',
        fontSize: '15px',
    }),
    option: (styles: any) => {
        return {
            ...styles,
            fontSize: '14px',
        };
    },
    placeholder: (defaultStyles: any) => ({
        ...defaultStyles,
        marginLeft: '-15px',
    }),
    singleValue: (provided: any) => {
        return {
            ...provided,
            marginLeft: '-15px',
            fontSize: '14px',
        };
    },
    menu: (defaultStyles: any) => {
        return {
            ...defaultStyles,
            zIndex: 999999
        };
    },
}

export const reactSelectDarkStyles = {
    control: (_: any, { selectProps: { width, isDisabled } }: any) => ({
        display: 'flex',
        width: width,
        padding: '1px 2px 1px 0',
        cursor: isDisabled ? 'not-allowed' : 'default',
        color: isDisabled ? '#aaa' : 'var(--primary-80)',
        backgroundColor: isDisabled ? '#e9ecef' : 'var(--primary-30)',
        borderRadius: '0.5rem',
    }),
    placeholder: (defaultStyles: any) => ({
        ...defaultStyles,
        paddingLeft: '5px',
        color: 'var(--primary-80)'
    }),
    input: (defaultStyles: any) => ({
        ...defaultStyles,
        paddingLeft: '3px',
        color: 'var(--primary-80)'
    }),
    singleValue: (provided: any) => {
        return {
            ...provided,
            paddingLeft: '5px',
            color: 'var(--primary-80)'
        };
    },
    menu: (defaultStyles: any) => {
        return {
            ...defaultStyles,
            zIndex: 999999,
            color: 'var(--primary-80)',
            backgroundColor: 'var(--primary-30)',
        };
    },
    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? 'var(--primary-60)'
            : state.isFocused
                ? 'var(--primary-40)'
                : 'var(--primary-30)',
        color: state.isSelected ? 'white' : 'var(--primary-60)',
        '&:active': {
            backgroundColor: 'var(--primary-50)',
        },
    }),
}

export const customNewStyles = {
    control: (provided: any, state: any) => ({
        ...provided,
        height: 32,
        minHeight: 32,
        padding: '0 0',
        backgroundColor: state.hasValue
            ? 'var(--primary-902)'
            : '#F2F2F2',
        color: 'var(--primary-40)',
        fontSize: 12,
        fontWeight: 600,
        borderRadius: 8,
        border: '1px solid var(--primary-802)',
        boxShadow: 'none',
        cursor: 'pointer',
        borderBottomLeftRadius: state.menuIsOpen ? 0 : 8,
        borderBottomRightRadius: state.menuIsOpen ? 0 : 8,
    }),

    placeholder: (provided: any) => ({
        ...provided,
        color: 'var(--primary-40)',
        fontSize: 12,
        fontWeight: 600,
    }),

    singleValue: (provided: any) => ({
        ...provided,
        color: 'var(--primary-40)',
        fontWeight: 600,
    }),

    dropdownIndicator: (provided: any) => ({
        ...provided,
        color: 'var(--primary-40)',
        padding: 0,
    }),

    indicatorsContainer: (provided: any) => ({
        ...provided,
        padding: '0 8px',
    }),

    indicatorSeparator: () => ({
        display: 'none',
    }),

    menu: (provided: any) => ({
        ...provided,
        backgroundColor: '#F2F2F2',
        fontWeight: 600,
        border: '1px solid var(--primary-802)',
        borderTop: '1px solid var(--primary-802)',
        marginTop: 0,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        zIndex: 999,
        overflow: 'hidden',
    }),

    option: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isFocused
            ? 'var(--primary-60)'
            : '#F2F2F2',
        color: state.isFocused ? 'white' : 'var(--primary-60)',
        fontWeight: 600,
        fontSize: 12,
        cursor: 'pointer',
        padding: '8px 12px',
    }),
};